<template>
  <v-snackbar
    v-if="notification"
    v-model="show"
    :color="notification.color"
    :timeout="notification.timeout"
    top
  >
    <span class="p-snack-text" v-if="notification.defaultError"
      >Something went wrong! Try again, or contact us at
      <a href="mailto:support@flewidtech.com" target="_blank"
        >support@flewidtech.com</a
      >
    </span>
    <span class="p-snack-text" v-else>
      <template v-if="notification.text"
        >{{ notification.text }}<br
      /></template>
      <template v-if="notification.arrText">{{
        notification.arrText
      }}</template>
    </span>

    <template v-slot:actions v-if="notification.closable">
      <v-btn
        aria-label="Close notification"
        class="p-snack-close"
        icon="mdi-close"
        size="small"
        variant="text"
        @click="show = false"
      />
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    show: false
  }),

  computed: {
    ...mapState('notifications', {
      notification: (state) => state.notifications[0]
    })
  },

  methods: {
    ...mapActions('notifications', ['removeNotification'])
  },

  watch: {
    notification() {
      this.show = true
    },

    show(current) {
      if (!current) {
        this.removeNotification()
      }
    }
  }
}
</script>

<style scoped>
.p-snack-text,
.p-snack-text a {
  font-weight: bold;
  color: white;
}

.p-snack-close {
  color: white !important;
  flex: 0 0 36px;
  height: 36px;
  min-width: 36px;
  width: 36px;
}
</style>
